export default {
    computed: {
        currentSchoolYear() {
            return this.determineSchoolYear(this.$moment().format("Y-MM-DD"));
        },
        selectedSchoolYear: {
            get: function() {
                const pages = this.$store.getters.getPages;
                if (pages.singpause && pages.singpause.schoolYear) {
                    return pages.singpause.schoolYear;
                } else {
                    return this.currentSchoolYear;
                }
            },
            set: function(val) {
                this.$store.dispatch("pages", {
                    singpause: {
                        schoolYear: val
                    }
                });
            }
        },
        currentDate() {
            return this.$moment().format("Y-MM-DD");
        }
    },
    methods: {
        determineSchoolYear(date) {
            const parsedDate = this.$moment(parsedDate);
            const month = parsedDate.format("M");
            var year = parsedDate.format("Y");
            if (month >= 9) {
                return year;
            } else {
                return year - 1;
            }
        },
        printSchoolYear(school_year) {
            var school_year_int = parseInt(school_year);
            return school_year_int + "/" + (school_year_int + 1);
        },
        async fetchSchools() {
            this.schools.busy = true;
            const response = await this.api.getSchools();
            if (response.ok && response.json.collection) {
                var schools = response.json.collection.map(item => {
                    return { value: item.id, text: item.name };
                });
                /*schools.push({
                    text: "Bitte Schule auswählen...",
                    value: null
                });*/
                this.schools.data = schools;
            } else {
                this.schools.data = [];
            }
            this.schools.busy = false;
        }
    }
};
